import React from "react";
import styled, { css, useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
import Badge from "components/bootstrap/Badge";
import { Icon } from "components/common";
import { LINK_TYPE, PAGE_TYPE, ACTION_TYPE } from "components/quick-jump/Constants";
import { ListGroupItem } from "components/bootstrap";
import StringUtils from "util/StringUtils";
const StyledListGroupItem = styled(ListGroupItem)(({ theme, $active }) => {
  const highlightColor = theme.utils.opacify(theme.utils.colorLevel(theme.colors.global.contentBackground, 10), 0.5);
  return css`
    display: flex;
    position: relative;
    cursor: pointer;
    transition: background-color 0.15s ease-in-out;

    ${$active && css`
      background-color: ${highlightColor};

      a {
        color: inherit;
        text-decoration: none;
      }
    `}
  `;
});
const FullWidthCol = styled.div`
  flex: 1;
`;
const HeaderRow = styled.div`
  max-height: 18px;
  display: flex;
  justify-content: space-between;
`;
const TypeColorIndicator = styled.div(
  ({ $color }) => css`
    background-color: ${$color};
    width: 3px;
    border-radius: 2px;
    left: -6px;
    position: relative;
  `
);
const FavIcon = styled(Icon)`
  margin-left: 3px;
  bottom: 2px;
  position: relative;
`;
const EntityType = styled.div(
  ({ theme }) => css`
    font-weight: normal;
    color: ${theme.colors.text.secondary};
    font-size: ${theme.fonts.size.small};
  `
);
const RecentBadge = styled(Badge)(
  ({ theme }) => css`
    font-weight: normal;

    .mantine-Badge-label {
      font-size: ${theme.fonts.size.tiny};
    }
  `
);
const ExternalIcon = styled(Icon)(
  ({ theme }) => css`
    margin-left: ${theme.spacings.xxs};
    font-size: ${theme.fonts.size.small};
    top: -1px;
    position: relative;
  `
);
const useTypeColor = (type) => {
  const theme = useTheme();
  if (type === PAGE_TYPE) {
    return theme.colors.variant.lighter.primary;
  }
  if (type === ACTION_TYPE) {
    return theme.colors.variant.lighter.warning;
  }
  return theme.colors.variant.lighter.success;
};
const SearchResultEntry = ({ item, itemProps, isActive, lastOpened, favorite }) => {
  const { t } = useTranslation("common");
  const typeColor = useTypeColor(item.type);
  return /* @__PURE__ */ React.createElement(StyledListGroupItem, { $active: isActive, ...itemProps }, /* @__PURE__ */ React.createElement(TypeColorIndicator, { $color: typeColor }), /* @__PURE__ */ React.createElement(FullWidthCol, null, /* @__PURE__ */ React.createElement(HeaderRow, null, /* @__PURE__ */ React.createElement(EntityType, null, StringUtils.toTitleCase(item.type, "_")), lastOpened ? /* @__PURE__ */ React.createElement(RecentBadge, null, t("quick_jump.recent")) : null), /* @__PURE__ */ React.createElement("div", null, item.title, item.type === LINK_TYPE && /* @__PURE__ */ React.createElement(ExternalIcon, { name: "open_in_new" }), favorite ? /* @__PURE__ */ React.createElement(FavIcon, { name: "star", type: "solid", size: "xs" }) : null)));
};
export default SearchResultEntry;
